import { render, staticRenderFns } from "./ButtonEditor.vue?vue&type=template&id=be6363f6&scoped=true"
import script from "./ButtonEditor.vue?vue&type=script&lang=js"
export * from "./ButtonEditor.vue?vue&type=script&lang=js"
import style0 from "./ButtonEditor.vue?vue&type=style&index=0&id=be6363f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6363f6",
  null
  
)

export default component.exports